module.exports = __webpack_public_path__ + "static/img/logo.470bd1d9.svg";